'use strict';

product.$inject = ["common", "textBuilder", "MediPimData", "ProductTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.product = product;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function product(common, textBuilder, MediPimData, ProductTypes) {
    // prodFactory and getClass are created to be able to use the ProductModel recursively
    var prodFactory = {
        getClass: function getClass() {

            var clazz = function Product() {
                var defaults = {
                    id: null,
                    name: '',
                    discountName: '',
                    displayName: '',
                    message: null,
                    type: '',
                    image: '',
                    sellerId: 0,
                    sellerName: '',
                    brand: '',
                    discount: null,
                    productNumber: '',
                    EAN: '',
                    ATC: '',
                    UDI: '',
                    NUT: '',
                    promocode: '',
                    price: 0,
                    tax: 0,
                    other_discounts: [],
                    included_products: [],
                    amountInPack: 0,
                    minQuantityInPanacee: 0,
                    maxQuantityInPanacee: 0,
                    maxDiscount: 0,
                    // calculated totals and discount
                    quantity: 0,
                    internalQuantity: 1,
                    totalPriceDiscountIds: [],
                    activeDiscountIds: [],
                    discountAmount: 0,
                    totalPriceWithoutDiscount: 0,
                    totalDiscount: 0,
                    totalPriceWithDiscount: 0,
                    discountText: '',
                    time_remaining: null,
                    isInCart: false,
                    isSellableInStore: null,
                    isSellableAsSingleProduct: true,
                    productSourceCode: null,
                    portalContractTypeCode: null,
                    counterStatus: null,
                    counter: null,
                    mediPimData: null,
                    productNumberAndPromo: '',
                    grossProfit: undefined,
                    grossProfitAmount: undefined,
                    panaceeQuantity: 0,
                    totalProductsAmountInPanacee: 0,
                    expirationDate: null,
                    quantityToAddForHighestDiscount: 0,
                    unitPriceWithDiscount: 0,
                    topNewsitems: null,
                    productDiscounts: null,
                    certificates: []
                };

                _lodash2.default.extend(this, defaults);
            };

            _lodash2.default.extend(clazz.prototype, {
                getTotalQuantity: function getTotalQuantity() {
                    return this.type === ProductTypes.panacee.clientValue ? _lodash2.default.sumBy(this.included_products, function (p) {
                        return p.quantity * p.internalQuantity;
                    }) : this.quantity;
                },

                getTotalPriceWithoutDiscount: function getTotalPriceWithoutDiscount() {
                    var result = this.type === ProductTypes.panacee.clientValue ? _lodash2.default.sumBy(this.included_products, function (p) {
                        if (p.maxOrderAmount > 0 && p.quantity > p.maxOrderAmount) {
                            return p.maxOrderAmount * p.price;
                        }
                        if (p.minOrderAmount > 0 && p.quantity >= p.minOrderAmount) {
                            return p.price * p.quantity;
                        } else if (p.minOrderAmount > 0 && p.quantity < p.minOrderAmount) {
                            return 0;
                        }

                        return p.price * p.quantity;
                    }) : this.price * this.quantity;
                    result = Math.round(result * 10000) / 10000;

                    //console.log('getTotalPriceWithoutDiscount', result);

                    return result;
                },

                getTotalPriceWithDiscount: function getTotalPriceWithDiscount() {
                    var result = this.totalPriceWithoutDiscount - this.totalDiscount;
                    result = Math.round(result * 10000) / 10000;

                    //console.log('getTotalPriceWithDiscount', result);

                    return result;
                },

                getTotalDiscount: function getTotalDiscount() {
                    // discount is always on group level (or product level for a single product)
                    var totalPriceWithoutDiscount = this.getTotalPriceWithoutDiscount();
                    var discountPct = this.getDiscountPctForQuantity();
                    var result = totalPriceWithoutDiscount * discountPct / 100;
                    return Math.round(result * 10000) / 10000;
                },

                updateTotals: function updateTotals() {
                    var _this = this;

                    this.quantity = this.getTotalQuantity();
                    this.totalDiscount = this.getTotalDiscount();
                    this.unitPriceWithDiscount = this.price - this.price * this.discountPct / 100;
                    this.totalPriceWithoutDiscount = this.getTotalPriceWithoutDiscount();
                    this.totalPriceWithDiscount = this.getTotalPriceWithDiscount();
                    this.quantityToAddForHighestDiscount = this.getQuantityToAddForHighestDiscount();
                    this.panaceeProductMinMaxMessage = this.getPanaceeProductMinMaxMessage();
                    this.totalProductsAmountInPanacee = 0;
                    this.included_products.forEach(function (panaceeProduct) {
                        _this.totalProductsAmountInPanacee += panaceeProduct.panaceeQuantity;
                    });
                },

                getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
                    return this.highestDiscount ? this.highestDiscount.amount - this.getTotalQuantity() : 0;
                },

                getDiscountPctForQuantity: function getDiscountPctForQuantity() {
                    // NOTE: for now, we assume that all discounts are percentages
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0 || !this.getAllConditionsMet()) {
                        return 0;
                    }

                    // NOTE: discount ranges are sorted from high to low
                    var qty = this.getTotalQuantity();
                    for (var i = 0; i < this.discount.discountRanges.length; i++) {
                        var range = this.discount.discountRanges[i];
                        if (qty >= range.amount) {
                            return range.discount;
                        }
                    }

                    return 0;
                },
                getAllConditionsMet: function getAllConditionsMet() {
                    var met = true;
                    this.included_products.forEach(function (panaceeProduct) {
                        if (panaceeProduct.minOrderAmount > panaceeProduct.quantity) {
                            met = false;
                        }
                    });
                    return met;
                },
                getHighestDiscount: function getHighestDiscount() {
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0) {
                        return null;
                    }
                    return this.discount.discountRanges[0];
                },

                getLowestDiscount: function getLowestDiscount() {
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0) {
                        return null;
                    }
                    return this.discount.discountRanges[this.discount.discountRanges.length - 1];
                },

                getPiecesText: function getPiecesText(i) {
                    return i === 1 ? 'st.' : 'st.';
                },

                getPanaceeProductMinMaxMessage: function getPanaceeProductMinMaxMessage() {
                    if (this.minQuantityInPanacee && this.minQuantityInPanacee > 0 && this.maxQuantityInPanacee && this.maxQuantityInPanacee > 0 && this.maxQuantityInPanacee !== 999999) {
                        return 'min. ' + this.minQuantityInPanacee + ' ' + this.getPiecesText(this.minQuantityInPanacee) + ', max. ' + this.maxQuantityInPanacee + ' ' + this.getPiecesText(this.maxQuantityInPanacee);
                    }
                    if (this.minQuantityInPanacee && this.minQuantityInPanacee > 0) {
                        return 'min. ' + this.minQuantityInPanacee + ' ' + this.getPiecesText(this.minQuantityInPanacee);
                    }
                    if (this.maxQuantityInPanacee && this.maxQuantityInPanacee > 0 && this.maxQuantityInPanacee !== 999999) {
                        return 'max. ' + this.maxQuantityInPanacee + ' ' + this.getPiecesText(this.maxQuantityInPanacee);
                    }
                },

                getCartCurrentDiscount: function getCartCurrentDiscount(cartProducts) {
                    var this_ = this;

                    var productSearch = cartProducts.find(function (shoppingCartProduct) {
                        if (this_.nationalNumber) {
                            return shoppingCartProduct.productNumber === this_.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === this_.id;
                            });
                            return shoppingCartProductSearch;
                        }
                    });
                    return productSearch ? productSearch.discountPercentage : 0;
                },

                getTotalPriceDiscountId: function getTotalPriceDiscountId(cartProducts) {
                    var _this2 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.productNumber === _this2.nationalNumber;
                    });
                    return productSearch ? productSearch.totalPriceDiscountId : 0;
                },

                getTotalPriceDiscountCode: function getTotalPriceDiscountCode(cartProducts) {
                    var _this3 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.productNumber === _this3.nationalNumber;
                    });
                    return productSearch ? productSearch.totalPriceDiscountPromoCode : 0;
                },

                getPanaceeQuantity: function getPanaceeQuantity() {
                    var quantity = 0;
                    if (this.quantity >= this.minOrderAmount && (this.maxOrderAmount === 0 || this.quantity <= this.maxOrderAmount)) {
                        quantity = this.quantity * this.internalQuantity;
                    } else if (this.quantity > this.maxOrderAmount) {
                        quantity = this.maxOrderAmount * this.internalQuantity;
                    }
                    return quantity;
                },

                //update all the discount fields
                getCartFields: function getCartFields(product, shoppingCartProducts) {
                    //Find the product that has to updated in the list of products that are in the shoppingcart
                    var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                        if (product.nationalNumber && shoppingCartProduct.productNumber === product.nationalNumber) {
                            return shoppingCartProduct.productNumber === product.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === product.id;
                            });
                            return shoppingCartProductSearch ? true : false;
                        }
                    });

                    //SINGLE PRODUCT - PARENT PRODUCT update all the product fields with the values from the server
                    if (productToUpdate) {
                        product.discountPct = productToUpdate.discountPercentage;
                        product.grossProfit = productToUpdate.grossProfit * 100;
                        product.grossProfitAmount = productToUpdate.grossProfitAmount;
                        product.promocode = productToUpdate.discountPromoCode;
                        product.quantity = productToUpdate.amount;
                        product.totalDiscount = productToUpdate.discountAmount;
                        product.activeDiscountId = productToUpdate.discountId;
                        product.totalPriceDiscountId = productToUpdate.totalPriceDiscountId;
                        product.totalPriceDiscountPromoCode = productToUpdate.totalPriceDiscountPromoCode;

                        if (typeof product.getPanaceeQuantity === 'function') {
                            product.panaceeQuantity = product.getPanaceeQuantity();
                        } else {
                            product.panaceeQuantity = 0;
                        }

                        //clear the discountId's
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];

                        //add the new discount id's
                        productToUpdate.productWithPossibleDiscounts.map(function (discount) {
                            product.activeDiscountIds.push(discount.discountIds);
                            product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                        });
                    } else {
                        product.quantity = 0;
                        product.discountPct = 0;
                        product.promocode = null;
                        product.activeDiscountId = 0;
                        product.totalPriceDiscountId = 0;
                        product.totalPriceDiscountPromoCode = null;
                        product.panaceeQuantity = 0;
                        product.grossProfit = 0;
                        product.grossProfitAmount = 0;
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];
                    }

                    // PANACEE if the product is a panacee update the childproducts
                    if (product.type === ProductTypes.panacee.clientValue) {

                        product.totalProductsAmountInPanacee = 0;

                        product.included_products.forEach(function (includedProduct) {

                            //find the child product in the shoppingcart
                            var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                                if (includedProduct.nationalNumber && shoppingCartProduct.productNumber === includedProduct.nationalNumber) {
                                    return shoppingCartProduct.productNumber === includedProduct.nationalNumber;
                                } else {
                                    var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                        return productWithPossibleDiscount.id === product.id;
                                    });
                                    return shoppingCartProductSearch ? true : false;
                                }
                            });

                            if (productToUpdate) {

                                //update the total products amount
                                product.totalProductsAmountInPanacee += productToUpdate.amount * includedProduct.internalQuantity;

                                //update the child
                                includedProduct.grossProfit = productToUpdate.grossProfit * 100;
                                includedProduct.grossProfitAmount = productToUpdate.grossProfitAmount;
                                includedProduct.promocode = productToUpdate.discountPromoCode;
                                includedProduct.discountPct = productToUpdate.discountPercentage;
                                includedProduct.panaceeQuantity = includedProduct.getPanaceeQuantity();

                                //update the discount values for panacee contents
                                var productDiscount = productToUpdate.productWithPossibleDiscounts.find(function (productWithDiscount) {
                                    return productWithDiscount.id === includedProduct.id;
                                });

                                if (productDiscount) {
                                    includedProduct.activeDiscountIds = [productDiscount.discountIds];
                                    includedProduct.totalPriceDiscountIds = [productDiscount.totalPriceDiscountId];
                                    includedProduct.totalPriceDiscountPromoCode = productDiscount.totalPriceDiscountPromoCode;
                                }
                            } else {
                                includedProduct.discountPct = 0;
                                includedProduct.activeDiscountIds = [];
                                includedProduct.promocode = null;
                                includedProduct.totalPriceDiscountIds = 0;
                                includedProduct.totalPriceDiscountPromoCode = null;
                                includedProduct.grossProfit = 0;
                                includedProduct.panaceeQuantity = 0;
                            }
                        });
                    } else if (product.type === common.serverTypes.getProductType('PROMOPACK')) {
                        // PROMOPACK if the product is a panacee update the childproducts
                        product.included_products.forEach(function (includedProduct) {
                            includedProduct.totalPriceDiscountIds = product.totalPriceDiscountIds;
                            includedProduct.activeDiscountIds = product.activeDiscountIds;
                            includedProduct.discountPct = product.getCartCurrentDiscount(shoppingCartProducts);
                            includedProduct.totalPriceDiscountId = product.getTotalPriceDiscountId(shoppingCartProducts);
                            includedProduct.totalPriceDiscountPromoCode = product.getTotalPriceDiscountCode(shoppingCartProducts);
                        });
                    }

                    //On a product detail page, update the totals
                    product.updateTotals();

                    //Return the updated product
                    return product;
                }

            });

            clazz.create = function (resource, cart, parentProduct, rootProductType, topNewsitems, productDiscounts) {
                var product = new clazz();
                product.type = common.serverTypes.getProductType(resource.productTypeCode);
                product.id = resource.productId;
                product.name = common.toPascalCase(resource.productName);
                product.displayName = common.toPascalCase(resource.discountName || resource.productName);
                product.message = resource.message; //TODO
                product.price = resource.pharmacyPrice;
                product.publicPrice = resource.publicPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.image = resource.imagePath;
                product.sellerId = resource.sellerId;
                product.sellerName = resource.sellerName;
                product.nationalNumber = resource.productNumber ? resource.productNumber : resource.nationalNumber;
                product.promocode = resource.promocode;
                product.productNumberAndPromo = textBuilder.getProductNumberAndPromo(product.nationalNumber, product.promocode);
                product.isSellableInStore = resource.isSellableInStore ? true : false;
                product.isSellableAsSingleProduct = resource.isSellableAsSingleProduct;
                product.productSourceCode = resource.productSourceCode;
                product.portalContractTypeCode = resource.portalContractTypeCode;
                product.counterStatus = resource.counterStatus;
                product.counter = resource.counter;
                product.maxDiscount = resource.maxDiscount;
                product.grossProfit = resource.grossProfit;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.tax = resource.tax;
                product.amountInPack = resource.quantity;
                product.minOrderAmount = resource.minOrderAmount;
                product.maxOrderAmount = resource.maxOrderAmount;
                product.minQuantityInPanacee = resource.minQuantityInPanacee || 0;
                product.maxQuantityInPanacee = resource.maxQuantityInPanacee || 999999;
                product.time_remaining = resource.time_remaining;
                product.orderTotalPriceDiscountIds = resource.orderTotalPriceDiscountIds || [];
                product.allowSpecial = resource.allowSpecial;
                product.internalQuantity = resource.internalQuantity;
                product.totalProductsAmountInPanacee = 0;
                product.minOrderAmountRequired = resource.minOrderAmountRequired;
                product.expirationDate = resource.expirationDate;
                product.topNewsitems = topNewsitems;
                product.productDiscounts = productDiscounts;
                product.isVipSeller = resource.isVipSeller;
                // set the discount ranges
                var discountRanges = _lodash2.default.map(resource.discountRanges, function (discountRange) {
                    return {
                        discount: parseFloat(discountRange.discount),
                        discountValueTypeSymbol: discountRange.discountValueTypeSymbol,
                        amount: parseInt(discountRange.from)
                    };
                });

                // set the discount
                product.discountId = resource.discountId;
                product.discount = {
                    id: resource.discountId,
                    name: resource.discountName,
                    description: resource.discountDescription,
                    startDate: resource.discountStartDate,
                    endDate: resource.discountEndDate,
                    sellerName: resource.sellerName,
                    discountType: resource.productTypeCode,
                    discountRanges: _lodash2.default.orderBy(discountRanges, 'amount', 'desc')
                };

                // set the medipim data
                if (resource.mediPimData) {
                    product.mediPimData = MediPimData.create(resource.mediPimData);
                }

                // Get calculated fields for toolbar data
                product.highestDiscount = product.getHighestDiscount();
                product.lowestDiscount = product.getLowestDiscount();

                //calculated discount fields form the cart
                if (cart) {
                    product = product.getCartFields(product, cart);
                }

                // create the included products if the product is a panacee or pack
                var includedProduct = null;
                product.included_products = [];
                if (product.type === ProductTypes.pack.clientValue && resource.promoPackContents && resource.promoPackContents.length > 0) {
                    for (var i = 0; i < resource.promoPackContents.length; i++) {
                        resource.promoPackContents[i].isSellableInStore = true;
                        includedProduct = prodFactory.getClass().create(resource.promoPackContents[i], cart, product, rootProductType, true);
                        includedProduct.quantity = resource.promoPackContents[i].quantity; //set the quantity for promopack only
                        product.included_products.push(includedProduct);
                    }
                }

                if (product.type === ProductTypes.panacee.clientValue && resource.panaceeContents && resource.panaceeContents.length > 0) {
                    for (var _i = 0; _i < resource.panaceeContents.length; _i++) {
                        resource.panaceeContents[_i].isSellableInStore = true;
                        includedProduct = prodFactory.getClass().create(resource.panaceeContents[_i], cart, product, rootProductType, true);
                        product.included_products.push(includedProduct);
                    }
                }

                return product;
            };

            return clazz;
        }
    };

    return prodFactory;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/productModel.js
// module id = 775
// module chunks = 0